import { render, staticRenderFns } from "./AdminAside.vue?vue&type=template&id=22bb78ae"
import script from "./AdminAside.vue?vue&type=script&lang=js"
export * from "./AdminAside.vue?vue&type=script&lang=js"
import style0 from "./AdminAside.vue?vue&type=style&index=0&id=22bb78ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports